import React from "react";
import { useAuth } from "@/context/AuthContext";
import { Navigate, useLocation } from "react-router-dom";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (!user) {
    // Send unauthenticated users to landing (login is reachable via header).
    return <Navigate to="/" replace state={{ from: location.pathname }} />;
  }
  return children;
}
